export default {
  'registerBenefit.member_recruitment': '会員募集',
  'registerBenefit.apply': '会員登録申請',
  'registerBenefit.follow_friend_tip': 'ブランドの友だちになると特典通知を受け取れます。',
} as Record<string, string>;
